import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'

@Component({
	standalone: true,
	selector: 'feature-pm-concierge-modal-success-content',
	templateUrl: './modal-success.component.html',
	styleUrls: ['./modal-success.component.scss'],
	imports: [CommonModule, MatIconModule],
})
export class ConciergeModalSucessComponent {
	public message: string = inject(MAT_DIALOG_DATA)
	constructor(private dialogRef: MatDialogRef<ConciergeModalSucessComponent>) {
		setTimeout(() => this.dialogRef.close(), 2500)
	}
}
